<ng-container *ngIf="numCandidates$ | async as numCandidates">
	<label>{{numCandidates.total}} <span>+{{numCandidates.thisWeek}} this week</span></label>
	<label>Total Candidates</label>
</ng-container>
